<div class="row mt-3" *ngIf="hasCustomers">
  <div class="col-sm-12">
    <tan-table [columnConfig]="columnConfig" [data]="customers" [loading]="(customersLoading$ | async)" [error]="(customersError$ | async)" [actionButtons]="actionButtons" [iconClass]="iconClass"
      [totalPages]="pageCount" [itemCount]="itemCount" [hasActionCol]="true" [currentPage]="currentPage"
      (onPageClick)="paginate($event)" (onClickViewItem)="viewItem($event)" (onClickRetry)="retry()"
      [canBulkEdit]="false" [page]="'customers'" (onActionClick)="actionClickEvent($event)"
      (searchTerm)="search($event)" (onClickSort)="sort($event)">
    </tan-table>
  </div>
</div>